import React, { useState, useEffect } from 'react';
import { Col, Row } from 'reactstrap';
import { useFormikContext } from 'formik';
import { FormInputField } from '../../common/components/formFields';

function VehicleDescriptionForm() {
  const { values } = useFormikContext();
  const [charCount, setCharCount] = useState(0);
  const MAX_CHARS = 30;

  useEffect(() => {
    if (values.vehicleHighlightedInfo) {
      setCharCount(values.vehicleHighlightedInfo.length);
    } else {
      setCharCount(0);
    }
  }, [values.vehicleHighlightedInfo]);

  return (
    <>
      <Row>
        <Col md="12" className="vehicle-description__description-column">
          <FormInputField
            inputClassName="vehicle-description__textarea"
            label="Description"
            name="description"
            type="textarea"
          />
        </Col>
      </Row>
      <Row>
        <Col md="12" className="vehicle-description__description-column">
          <FormInputField
            label="Default description"
            inputClassName="vehicle-description__textarea"
            name="defaultDescription"
            type="textarea"
          />
        </Col>
      </Row>

      <Row>
        <Col md="12" className="vehicle-description__description-column">
          <FormInputField
            label="Vehicle highlighted info"
            inputClassName=""
            name="vehicleHighlightedInfo"
            type="text"
            maxLength={MAX_CHARS}
          />
          <div className="character-counter">
            <small className="character-counter-small">
              {charCount} / {MAX_CHARS}
            </small>
          </div>
        </Col>
      </Row>
    </>
  );
}

export default VehicleDescriptionForm;
